export default __webpack_public_path__ + "static/media/ShareMobile.f77fef28.png";